import React, { FunctionComponent, ReactNode } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

const Outer = styled.div`
  display: flex;
  gap: 1rem 0;
  justify-content: center;
  max-width: calc(12rem * 4 + 3rem);
  flex-wrap: wrap;
  & + & {
    margin-top: 1rem;
  }
  @media (max-width: 50rem){
    --columns: 2 !important;
  }
`

const Item = styled(Link)`
  margin: 0 calc(-0.125rem / 2);
  display: block;
  padding: 0.5rem 1rem;
  min-width: 8rem;
  border-style: solid;
  border-color: #9c91bd;
  border-width: 0 0.125rem;
  text-align: center;
  font-size: 0.8rem;
  width: 12rem;
  box-sizing: border-box;
  @media (max-width: 40rem){
    border-color: var(--nav-border, #f00) !important;
  }
  &:hover {
    text-decoration: underline;
  }
`

type SectionNavigatorProps = {
  labelMap: Map<string, ReactNode>
  columns?: number;
}
export const SectionNavigator: FunctionComponent<SectionNavigatorProps> = ({labelMap, columns}) => {
  return <Outer style={{'--columns': columns ?? 4}}>
    {
      Array.from(labelMap).map(([key, value]) => {
        return <Item key={key} to={{hash: key}} onClick={() => {
          const target = document.getElementById(key.replace(/^#/, ''))
          if(target){
            const y = target.getBoundingClientRect().top + window.scrollY - 128
            window.scrollTo({
              top: y,
              behavior: 'smooth'
            })
          }
        }}>{value}</Item>
      })
    }
  </Outer>
}